import { ROUTES } from '@constants/routes';
import IconButton from '@g17eco/molecules/button/IconButton';
import { generateUrl } from '@routes/util';
import { useHistory } from 'react-router-dom';
import type { MaterialitySurveyModelMinData } from '../../api/materiality-assessment';
import { useUnlockAssessment } from '../../hooks/useUnlockAssessment';
import { isAssessmentPaid } from '../../utils';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';

export const AssessmentPaymentStatus = ({
  survey,
}: {
  survey: Pick<MaterialitySurveyModelMinData, '_id' | 'payment' | 'initiativeId'>;
}) => {
  const history = useHistory();
  const { handleUnlock } = useUnlockAssessment();
  const isPaid = isAssessmentPaid(survey);
  if (isPaid) {
    return (
      <SimpleTooltip text='View insights'>
        <IconButton
          icon='fal fa-magnifying-glass'
          outline={false}
          color='transparent'
          onClick={() =>
            history.push(
              generateUrl(ROUTES.MATERIALITY_TRACKER_INSIGHTS, {
                initiativeId: survey.initiativeId,
                insightSurveyId: survey._id,
              }),
            )
          }
        />
      </SimpleTooltip>
    );
  }

  return (
    <SimpleTooltip text='Unlock assessment now'>
      <IconButton
        icon='fal fa-magnifying-glass-dollar'
        onClick={() => handleUnlock(survey)}
        outline={false}
        color='transparent'
        className='text-ThemeWarningMedium'
      />
    </SimpleTooltip>
  );
};
